var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ref) {
            var cancel = ref.cancel
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: {
                    click: function($event) {
                      return cancel()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("message.button.close")) +
                      "\n    "
                  )
                ]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("message.subscription.all_bookings")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "section",
        [
          _vm._l(_vm.orders, function(order) {
            return [
              _c("div", { staticClass: "card shadow-sm" }, [
                _c("div", { staticClass: "card-body px-0" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-2 text-center" }, [
                      _c("h5", [
                        _vm._v(
                          _vm._s(_vm.getFormattedDate(order.cleaning_date, "D"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("h4", [
                        _vm._v(
                          _vm._s(
                            _vm.getFormattedDate(order.cleaning_date, "MMM")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-10" }, [
                      _c("div", [
                        _vm._v(
                          "\n                #" +
                            _vm._s(order.order_code) +
                            "\n                -\n                "
                        ),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.serviceParentName(
                                order.service_id,
                                _vm.globalState.services
                              )
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          "\n                " +
                            _vm._s(order.work_hour) +
                            " " +
                            _vm._s(_vm.$tc("message.hour", order.work_hour)) +
                            " • " +
                            _vm._s(_vm._f("duration")(order)) +
                            "\n              "
                        )
                      ]),
                      _vm._v(" "),
                      order.professional
                        ? _c(
                            "div",
                            { staticClass: "mt-2 d-flex align-items-center" },
                            [
                              _c("img", {
                                staticClass: "rounded-circle mr-3",
                                attrs: {
                                  src: order.professional.full_picture,
                                  width: "42"
                                }
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("firstName")(
                                      order.professional.full_name
                                    )
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 text-right" }, [
                      _c(
                        "span",
                        {
                          staticClass: "badge badge-pill py-2 px-3",
                          class:
                            order.status < 2 ? "badge-warning" : "badge-success"
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                order.status < 2
                                  ? _vm.$t("message.my_reservations.upcoming")
                                  : _vm.$t("message.order_status.completed")
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8a4bb7a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8a4bb7a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/components/SubscriptionOrdersModal.vue
// module id = 1643
// module chunks = 0